import XeroPaymentUpdateList from "../../features/XeroPaymentUpdateList/XeroPaymentUpdateList";
import "./XeroPaymentUpdateList.scss";

const XeroPaymentUpdateListPage = () => {
  return (
    <div>
      <XeroPaymentUpdateList/>
    </div>
  );
};

export default XeroPaymentUpdateListPage;
